/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RecordIdentityProviderConnectionAgentRequestBody = {
  /**
   * Okta application ID the agent is bound to. Empty clears it.
   */
  agentAppId?: string | undefined;
  /**
   * Okta AI agent ID. Empty clears it.
   */
  agentId?: string | undefined;
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type RecordIdentityProviderConnectionAgentRequestBody$Outbound = {
  agent_app_id?: string | undefined;
  agent_id?: string | undefined;
  id: string;
};

/** @internal */
export const RecordIdentityProviderConnectionAgentRequestBody$outboundSchema:
  z.ZodMiniType<
    RecordIdentityProviderConnectionAgentRequestBody$Outbound,
    RecordIdentityProviderConnectionAgentRequestBody
  > = z.pipe(
    z.object({
      agentAppId: z.optional(z.string()),
      agentId: z.optional(z.string()),
      id: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        agentAppId: "agent_app_id",
        agentId: "agent_id",
      });
    }),
  );

export function recordIdentityProviderConnectionAgentRequestBodyToJSON(
  recordIdentityProviderConnectionAgentRequestBody:
    RecordIdentityProviderConnectionAgentRequestBody,
): string {
  return JSON.stringify(
    RecordIdentityProviderConnectionAgentRequestBody$outboundSchema.parse(
      recordIdentityProviderConnectionAgentRequestBody,
    ),
  );
}
